<script setup>

</script>

<template>
  <div 
    class="container-fluid bg-light-blue py-5 position-relative overflow-hidden"
    dir="ltr"
  >
    <div
        class="position-absolute"
        style="top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 0"
    >
      <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fairlines-draw.svg?alt=media&token=1b36f835-84c7-47e9-92c6-e71c20fe0a5f" alt="" @error="handleImageError($event, 'HowItWorks')">
    </div>
    <div class="container">
      <h2 class="fw-bold text-center pt-3 pt-md-5">{{ t('howItWorksSmartTitle') }}</h2>
      <b-row class="row my-3 my-md-5">
        <b-col align-self="stretch" class="col-lg-4 mb-lg-0 order-3 order-lg-1 mb-3">
          <div class="card border-0 shadow-sm p-2 p-md-3 rounded-5 h-100">
            <div class="card-body d-flex flex-column text-end position-relative ">
              <div
                  class="step-number-badge position-absolute h4 rounded-circle d-flex justify-content-center align-items-center"
                  style="">
                3
              </div>
              <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fstep3.svg?alt=media&token=3109d1ec-849e-4434-bd44-0515717d694a" alt="step 3"
                   class="image-how-it-works mb-3" @error="handleImageError($event, 'HowItWorks')">
              <h4 class="fw-semibold text-right h4">
                {{ t('howItWorksNewStep3Title') }}
              </h4>
              <p class="h6 mb-0 text-muted text-right">
                {{ t('howItWorksNewStep3Desc') }}
              </p>
            </div>
          </div>
        </b-col>
        <b-col align-self="stretch" class="col-lg-4 mb-lg-0 order-2 order-lg-2 mb-3">
          <div class="card border-0 shadow-sm p-2 p-md-3 rounded-5 h-100">
            <div class="card-body d-flex flex-column text-end gap-md-3 position-relative">
              <div
                  class="step-number-badge position-absolute h4 rounded-circle d-flex justify-content-center align-items-center"
                  style="">
                2
              </div>
              <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fstep2.svg?alt=media&token=9b8aba8a-99c5-4952-b98b-24d593ee21af" alt="step 2"
                   class="image-how-it-works mb-3" @error="handleImageError($event, 'HowItWorks')">
              <h4 class="fw-semibold text-right h4">
                {{ t('howItWorksNewStep2Title') }}
              </h4>
              <p class="h6 mb-0 text-muted text-right">
                {{ t('howItWorksNewStep2Desc') }}
              </p>
            </div>
          </div>
        </b-col>
        <b-col align-self="stretch" class="col-lg-4 mb-lg-0 order-1 order-lg-3  mb-3">
          <div class="card border-0 shadow-sm p-md-3 p-2 rounded-5 h-100">
            <div class="card-body d-flex flex-column text-end gap-md-3 position-relative">
              <div
                  class="step-number-badge position-absolute h4 rounded-circle d-flex justify-content-center align-items-center"
                  style="">
                1
              </div>
              <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fstep1.svg?alt=media&token=3c66f4bb-ba14-423d-bf5a-e4c6ade381ef" alt="step 1"
                   class="image-how-it-works mb-3" @error="handleImageError($event, 'HowItWorks')">
              <h4 class="fw-semibold text-right h4">
                {{ t('howItWorksNewStep1Title') }}
              </h4>
              <p class="h6 mb-0 text-muted text-right">
                {{ t('howItWorksNewStep1Desc') }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-center pb-3 pb-md-5 position-relative" style="z-index: 2!important;">
        <button 
          class="btn btn-primary px-5 py-3 rounded-pill fw-semibold h5 z-2"
          @click="goToSerchattractionPage()"
        >
          {{ t('howItWorksNewViewBtn') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import imageErrorMixin from '../mixins/imageErrorMixin';
import { translationMixin } from '@/mixins/translationMixin';
export default {
  name: 'HowItWorksNew',
  mixins: [imageErrorMixin, translationMixin],
  methods: {
  ...mapActions(["goToSerchattractionPage",
                ]),
  },

};
</script>

<style scoped>
.image-how-it-works {
  height: 150px !important;
}
</style>